/**
 * Store for `DATA.events`
 * @module
 */

var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');
var freeze = require('../utils/freeze');

/**
 * Holds the data for every event
 */
module.exports = {
  initialize: function() {
    this.__state = {} as any;
    this.on(actionTypes.DATA_LOADED, this.__loadData);
  },

  /**
   * Retrieve all event data
   * @returns {module:behavior/event~Event[]}
   */
  getAll: function(): import('core/behavior/event').Event[] {
    return freeze.safeReference(_.values(this.__state));
  },

  getEventsMap: function() {
    return freeze.safeReference(this.__state);
  },

  /**
   * Retrieve a single event
   * @param {string} id
   * @returns {module:behavior/event~Event} event with the specified id
   */
  get: function(id:string): import('core/behavior/event').Event {
    return freeze.safeReference(this.__state[id]);
  },

  /**
   * Retrieve a single event by apiName
   * @param {string} apiName
   * @returns {module:behavior/event~Event}
   */
  getByApiName: function(apiName:string): import('core/behavior/event').Event {
    return freeze.safeReference(_.find(_.values(this.__state), {
      apiName: apiName,
    }));
  },

  getByPageId: function(pageId) {
    return freeze.safeReference(_.filter(this.__state, { pageId: pageId }));
  },

  /**
   * Loads event data into the store state
   * @param {Object} payload
   * @param {ClientData} payload.data
   * @private
   */
  __loadData: function(payload:any) {
    if (_.isEmpty(payload.data.events)) {
      return;
    }
    _.each(payload.data.events, _.bind(function(event) {
      if (!event.pageId) {
        event.pageId = event.viewId;
      }
      freeze.deepFreeze(event);
      this.__state[event.id] = event;
    }, this));
    this.emitChange();
  },
};
